/<template>
    <b-card no-body class="card-challenges-header">
      <!-- <b-button :to="parent + '/sub/' + link"> -->
        
        <div class="header" :style="{'background-image': `url(${item.src})`}">
            <p class="title">
              <PuSkeleton :loading="isLoading" :count="1" width='200px' height="40px">                              
                {{title}}
              </PuSkeleton>
            </p>
            <p class="subtitle">
              <PuSkeleton :loading="isLoading" :count="1" width='140px' height="20px">              
                {{subtitle}}
              </PuSkeleton>
            </p>
            <p class="subdate">
              <PuSkeleton :loading="isLoading" :count="1" width='260px'>              
                {{subdate}}
              </PuSkeleton>
            </p>
        </div>

          <b-button variant="link" class="footer">
              <div class="ranking">
                <div class="title">{{rankingTitle}}</div>
                <div class="bottom">
                  <PuSkeleton circle :loading="isLoading" :count="1" width="20px" height="20px">
                    <div class="target green">{{target}}</div>
                  </PuSkeleton>
                  <div class="rankingResult">
                    <PuSkeleton :loading="isLoading" :count="1" width="40px">                    
                      {{rankingResult}} 
                    </PuSkeleton>
                  </div>
                  <div class="rankingNumber">
                    <PuSkeleton :loading="isLoading" :count="1" width="20px">                    
                      / {{rankingNumber}}
                    </PuSkeleton>
                    </div>
                </div>
              </div>
              <div class="score">
                <div class="title">{{scoreTitle}}</div>
                <div class="number">
                  <PuSkeleton :loading="isLoading" :count="1" width="140px">                  
                    {{scoreNumber}}
                  </PuSkeleton>
                </div>
              </div>
              <div class="link ">
                <font-awesome-icon :icon="['fal', 'arrow-right']"/>
              </div>
            </b-button>

    </b-card>
</template>


<script>

//
export default {
  name: "CardChallengesHeader",
  components:{ 
  },
  props:{
    title:{
      type:String,
      default:'Pura Vida'
    },
    subtitle:{
      type:String,
      default:'Jeu concours'
    },
    subdate:{
      type:String,
      default:'DU 01 FÉVRIER AU 31 SEPTEMBRE 2020'
    },
    rankingTitle:{
      type:String,
      default:'Classement'
    },
    scoreTitle:{
      type:String,
      default:'Score'
    },
    ranking:{
      type:String,
      default:'Classement'
    },
    rankingNumber:{
      type:String,
      default:'1'
    },
    rankingResult:{
      type:String,
      default:'4'
    },    
    score:{
      type:String,
      default:'score'
    },
    scoreNumber:{
      type:String,
      default:'250 000'
    },
    target:{
      type:String,
      default:'+1'
    },

  },
  data(){
    return {
      isLoading:true,
      item:{
        src:'/img/challenges-img.png'
      },      
    }
  },
  methods : {
  },  
  mounted (){
  },
  created(){
    setTimeout(() => {
      this.isLoading = false;
      // this.majData();
    },2000)      
  }  
}
</script>